<button
    mat-menu-item
    class="se-menu-item se-menu-button"
    (mouseover)="mouseOverTriggerButton($event)"
    (mouseleave)="mouseLeaveTriggerButton($event)"
    [matMenuTriggerFor]="subMenu"
    translate
>
    {{ nameTranslationKey | translate }}
</button>
<mat-menu #subMenu="matMenu" yPosition="above" xPosition="before">
    <div
        class="se-mat-menu"
        (mouseover)="mouseOverMenu($event)"
        (mouseleave)="mouseLeaveMenu($event)"
        (click)="handleMenuClick($event)"
    >
        <div
            *ngFor="let menuItem of menuSettings"
            class="se-settings-item-container se-menu-item"
        >
            <span class="settings-key">{{ menuItem.name | translate }}</span>
            <div class="settings-entries">
                <ng-container *ngFor="let item of menuItem.settings">
                    <div
                        class="settings-entry-container"
                        [class]="classConfigToList(item.classes, menuDataValues[menuItem.id][item.name])"
                    >
                        <ng-container *ngIf="item.type === 'boolean'">
                            <mat-slide-toggle
                                [matTooltip]="item.tooltip"
                                [matTooltipShowDelay]="tooltipDelay"
                                *ngIf="item.icons.length < 2"
                                [checked]="!!menuDataValues[menuItem.id][item.name]"
                                (change)="handleChangeToggle($event, menuItem.id, item)"
                            >{{ item.nameTranslationKey | translate }}
                            </mat-slide-toggle>
                            <div class="icons-container" *ngIf="item.icons.length === 2">
                            <span class="icon-wrapper" *ngFor="let iconConf of item.icons">
                                <mat-icon
                                    [matTooltip]="item.tooltip"
                                    [matTooltipShowDelay]="tooltipDelay"
                                    *ngIf="iconConf.showMatchValue === menuDataValues[menuItem.id][item.name]"
                                    (click)="handleIconClick($event, iconConf, menuItem.id, item)"
                                >{{ iconConf.icon }}</mat-icon
                                >
                            </span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.type === 'number'">
                            <mat-form-field class="se-tight-form-field" appearance="outline">
                                <mat-label
                                ><span>{{ item.nameTranslationKey | translate }}</span></mat-label
                                >
                                <input
                                    matInput
                                    type="number"
                                    [value]="menuDataValues[menuItem.id][item.name]"
                                    (change)="handleChangeInput($event, menuItem.id, item)"
                                />
                            </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="item.type === 'string'">
                            <mat-form-field class="se-tight-form-field" appearance="outline">
                                <mat-label
                                ><span>{{ item.nameTranslationKey | translate }}</span></mat-label
                                >
                                <input
                                    matInput
                                    [value]="menuDataValues[menuItem.id][item.name]"
                                    (change)="handleChangeInput($event, menuItem.id, item)"
                                />
                            </mat-form-field>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

        </div>
    </div>
</mat-menu>


